import { Button, Text, makeStyles, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const getRegisterUrl = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const mainDomain = parts.length > 1 ? parts.slice(1).join(".") : hostname;
  const { protocol, port } = window.location;
  const portStr = port ? `:${port}` : "";
  return `${protocol}//register.${mainDomain}${portStr}`;
};

const useStyles = makeStyles({
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tokens.colorNeutralBackground3,
    padding: "16px",
  },
  card: {
    width: "min(480px, 100%)",
    display: "grid",
    gap: "12px",
    textAlign: "center",
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusXLarge,
    boxShadow: tokens.shadow16,
    padding: "24px",
  },
  title: {
    fontSize: tokens.fontSizeHero700,
    fontWeight: tokens.fontWeightSemibold,
  },
  subtitle: {
    color: tokens.colorNeutralForeground3,
  },
  actions: {
    marginTop: "4px",
    display: "flex",
    justifyContent: "center",
    gap: "12px",
  },
});

export default function TenantNotFound() {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <Text className={styles.title}>{t("tenant.notFoundTitle", "Tenant not found")}</Text>
        <Text className={styles.subtitle}>
          {t(
            "tenant.notFoundDescription",
            "We could not find this tenant. Please go back to the login page and try again.",
          )}
        </Text>
        <div className={styles.actions}>
          <Button appearance="primary" onClick={() => window.history.back()}>
            {t("nounPhrases.back", "Back")}
          </Button>
          <Button
            appearance="secondary"
            onClick={() => {
              window.location.href = getRegisterUrl();
            }}
          >
            {t("generic.register", "Register")}
          </Button>
        </div>
      </div>
    </div>
  );
}
